import moment from 'moment';

const PARIS_TZ = 'Europe/Paris';
const PARIS_DATETIME_FORMATS = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', moment.ISO_8601];

function getTimeZoneOffsetMs(utcDate, timeZone) {
    const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    const parts = dtf.formatToParts(utcDate);
    const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
    const asUTC = Date.UTC(
        get('year'),
        get('month') - 1,
        get('day'),
        get('hour'),
        get('minute'),
        get('second'),
    );
    return asUTC - utcDate.getTime();
}

/**
 * Interprète une date/heure enregistrée comme heure « murale » Europe/Paris
 * et retourne un moment représentant l'instant UTC correspondant.
 */
export function momentFromParisDateTime(dateTimeStr) {
    const m = moment(dateTimeStr, PARIS_DATETIME_FORMATS, true);
    if (!m.isValid()) {
        return moment(dateTimeStr);
    }
    const utcMs = Date.UTC(m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second());
    let guess = new Date(utcMs);
    for (let i = 0; i < 2; i++) {
        const offset = getTimeZoneOffsetMs(guess, PARIS_TZ);
        guess = new Date(utcMs - offset);
    }
    return moment(guess.getTime());
}

/** Affiche l'heure telle qu'enregistrée (heure de Paris), sans décalage navigateur. */
export function formatParisDateTime(dateTimeStr, format = 'DD/MM/YYYY à HH:mm') {
    const m = moment(dateTimeStr, PARIS_DATETIME_FORMATS, true);
    if (m.isValid()) {
        return m.format(format);
    }
    return momentFromParisDateTime(dateTimeStr).format(format);
}

export function isParisDateTimeSameOrBeforeNow(dateTimeStr) {
    return momentFromParisDateTime(dateTimeStr).isSameOrBefore(moment());
}
